import { faArrowDownShortWide, faArrowUpWideShort } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useMemo, useState } from "react";
import { Button, Card, Col, Container, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import PersonalIdentifier from "../../../common/PersonalIdentifier";
import { LLMDashboardMarkdownRenderer } from "../common/LLMDashboardMarkdownRenderer";
import { Evidence, VerificationState } from "../common/verification";

export const SectionChartingDetails = (props: {
    activeKey: string,
    data: any,
    scanMulti: any,
}) => {

    const [targetEvidence, setTargetEvidence] = useState<Evidence>();
    const [verificationState, setVerificationState] = useState<VerificationState>();
    const [showEvidenceIndex, setShowEvidenceIndex] = useState<number | null>(null);
    const [sortAsc, setSortAsc] = useState<boolean>(true);

    const timeline = useMemo(() => {
        if (!props.data) return [];

        const sorted = [...props.data].sort((a, b) => {
            if (a.time_pt < b.time_pt) return sortAsc ? -1 : 1;
            if (a.time_pt > b.time_pt) return sortAsc ? 1 : -1;
            return 0;
        });

        return sorted;
    }, [props.data, sortAsc]);

    return (
        <Card>
            <Card.Body>
                <Row>
                    <Col md={6} className="pt-1">
                        <strong>Annotated Timeline</strong>
                    </Col>
                    <Col md={6} className="text-right">
                        <OverlayTrigger
                            placement="bottom"
                            overlay={
                                <Tooltip>
                                    Sort Timeline
                                </Tooltip>
                            }
                        >
                            <Button
                                variant="link-secondary"
                                onClick={() => {
                                    setSortAsc(!sortAsc);
                                }}
                                size="sm"
                                className="dashboard-round-btn"
                            >
                                <FontAwesomeIcon icon={sortAsc ? faArrowDownShortWide : faArrowUpWideShort} />
                            </Button>
                        </OverlayTrigger>
                    </Col>
                </Row>
                <hr />
                {
                    timeline && timeline.map((item: any, index: number) => {
                        const verification: VerificationState = item.verification;
                        const isActive = item.relevant_to_tasks && item.relevant_to_tasks.includes(props.activeKey);
                        
                        return (
                            <div key={index}>
                                <Container>
                                    <Row>
                                        <Col className={`description-text mt-2 timeline-section ${isActive && "timeline-section-active"}`}
                                            // onClick={() => {
                                            //     setTargetEvidence({
                                            //         source: '',
                                            //         details: item.event_summary,
                                            //         date: item.time_pt,
                                            //     });
                                            //     setShowEvidenceIndex((showEvidenceIndex === null || showEvidenceIndex !== index) ? index : null); 
                                            //     setVerificationState(verification)
                                            // }}
                                        >
                                            <Row>
                                                <Col xs={10}>
                                                    <strong><PersonalIdentifier identifier={item.time_pt} /></strong>
                                                </Col>
                                                <Col xs={2} className="text-end">
                                                    {/* {verification && (
                                                        <span 
                                                            style={{ cursor: 'pointer' }}
                                                            title={verification.time_verified ? 
                                                                `Verified (${verification.matches.length} match${verification.matches.length !== 1 ? 'es' : ''})` : 
                                                                'Not found in scan data'
                                                            }
                                                        >
                                                            <OverlayTrigger placement="top" overlay={<Tooltip>{verification.time_verified ? <>Time Verified Data</> : <>Unvalidated Data - Use with Caution</>}</Tooltip>}>
                                                                <span style={{ cursor: 'pointer' }} className="me-2">
                                                                    <FontAwesomeIcon 
                                                                        icon={verification.time_verified ? faCheckCircle : faExclamationTriangle} 
                                                                        className={verification.time_verified ? "text-success" : "text-warning"}
                                                                    />
                                                                </span>
                                                            </OverlayTrigger>
                                                        </span>
                                                    )} */}
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <LLMDashboardMarkdownRenderer content={item.event_summary} scanMulti={props.scanMulti} />
                                                </Col>
                                            </Row>

                                            {/* {verificationState && verificationState.matches.length > 0 && (
                                                <Collapse in={showEvidenceIndex === index}>
                                                    <div>
                                                        <hr className="my-2" />
                                                        <Row>
                                                            <Col>
                                                                <small className="text-muted">
                                                                    <strong>Context Data:</strong>
                                                                </small>
                                                                {renderMatchDetails(verificationState)}
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                </Collapse>
                                            )} */}
                                        </Col>
                                    </Row>
                                </Container>
                            </div>
                        );
                    })
                }
                {/* <EvidenceModal showModal={showEvidenceModal} setShowModal={setShowEvidenceModal} verificationState={verificationState} evidence={targetEvidence} /> */}
            </Card.Body>
        </Card>
    );
};
